__turbopack_context__.v({
  "auto-complete": "_2BOsPa_auto-complete",
  "button": "_2BOsPa_button",
  "card": "_2BOsPa_card",
  "icon": "_2BOsPa_icon",
  "list": "_2BOsPa_list",
  "wrapper": "_2BOsPa_wrapper",
});
